import { Route, Routes } from 'react-router-dom';
import PublicLinkPage from './pages/PublicLinkPage/PublicLinkPage';
import { navigateToMyFiles } from 'router/navigation';
import ErrorView from '../_common/components/ErrorView/ErrorView';
import styles from './PublicContainer.module.scss';

const PublicContainer = () => {
  return (
    <div className={styles.root}>
      <Routes>
        <Route path="/:type/:hash" element={<PublicLinkPage />} />

        <Route
          path="*"
          element={
            <ErrorView
              error={{
                status: 404,
              }}
              onClick={navigateToMyFiles}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default PublicContainer;
